export enum TokenFormatEnum {
  SMS = 'SMS',
  EMAIL = 'EMAIL',
}
